import _objectSpread from "E:/Jweb/\u7ED3\u8BFE\u4F5C\u4E1A/KilaKila-Blog/kilakila-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import { reactive, ref, toRefs } from "@vue/reactivity";
import { getUserInfo, setUserInfo } from "../utils/storage";
import { logout, updateUserInfo } from "../api/user";
import router from "../router";
import { uploadImage } from "../api/image";
import { ElMessage } from "element-plus/lib/components";
import store from "../store";
export default {
  name: "Settings",
  setup: function setup() {
    var userInfo = reactive(getUserInfo());
    var isInEditMode = ref(false);
    var ruleFormRef = ref();
    var progress = ref(0);
    var isProgressVisible = ref(false);
    var ruleForm = reactive({
      nickName: userInfo.nickName,
      sex: userInfo.sex == "0" ? "男" : "女",
      email: userInfo.email,
      signature: userInfo.signature,
      phonenumber: userInfo.phonenumber,
      avatar: userInfo.avatar
    });
    var rules = reactive({
      nickName: [{
        required: true,
        message: "昵称不能为空",
        trigger: "blur"
      }],
      email: [{
        type: "email",
        required: true,
        message: "邮箱格式错误",
        trigger: "blur"
      }],
      phonenumber: [{
        required: false,
        message: "手机号码格式错误",
        trigger: "blur",
        pattern: /(^((\+86)|(86))?(1[3-9])\d{9}$)|(^(0\d{2,3})-?(\d{7,8})$)/
      }]
    });

    function handleLogout() {
      logout().then(function () {
        router.replace("/login");
      });
    }

    function openFileDialog() {
      document.getElementById("file-input").click();
    }

    function uploadAvatar() {
      var fileInput = document.getElementById("file-input");

      if (fileInput.files.length == 0) {
        return;
      }

      isProgressVisible.value = true;
      var file = fileInput.files[0];
      document.getElementById("avatar").src = URL.createObjectURL(file);
      uploadImage(file, progress).then(function (url) {
        ruleForm.avatar = url;
        isProgressVisible.value = false;
      }, function () {
        ElMessage.error("哎呀，头像上传出错啦~");
        isProgressVisible.value = false;
        document.getElementById("avatar").src = ruleForm.avatar;
      });
    }

    function saveEditInfo(form) {
      if (!form) return;
      form.validate(function (valid) {
        if (!valid) {
          ElMessage.error("前辈填写的个人信息有点小问题哦~");
          return;
        }

        Object.assign(userInfo, ruleForm);
        userInfo.sex = ruleForm.sex == "男" ? "0" : "1";
        updateUserInfo(userInfo).then(function (data) {
          setUserInfo(userInfo);
          isInEditMode.value = false;
          ElMessage.success("更新前辈个人信息成功啦");

          if (store.state.adminAbout.isAdmin) {
            store.commit("adminAbout/updateAdminInfo", userInfo);
          }
        });
      });
    }

    function cancelEditInfo() {
      Object.assign(ruleForm, userInfo);
      ruleForm.sex = userInfo.sex == "0" ? "男" : "女";
      document.getElementById("avatar").src = ruleForm.avatar;
      ruleFormRef.value.clearValidate();
      isInEditMode.value = false;
    }

    return _objectSpread(_objectSpread({}, toRefs(userInfo)), {}, {
      handleLogout: handleLogout,
      saveEditInfo: saveEditInfo,
      cancelEditInfo: cancelEditInfo,
      openFileDialog: openFileDialog,
      uploadAvatar: uploadAvatar,
      isProgressVisible: isProgressVisible,
      isInEditMode: isInEditMode,
      ruleFormRef: ruleFormRef,
      progress: progress,
      ruleForm: ruleForm,
      rules: rules
    });
  }
};